import itemMapper from '../../mappers/Item/item.mapper'
import { Item } from '../../schemas/Item'
import apiClient from '../apiClient'

class ItemService {
  /** Creates a new item for the authenticated entity. */
  async saveItem(itemData: Item) {
    try {
      const responseApi = await apiClient.post('/api/v2/item', itemData)
      return responseApi.data
    } catch (error) {
      throw error
    }
  }

  /** Updates an existing item for the authenticated entity. */
  async updateItem(itemData: Item) {
    try {
      const responseApi = await apiClient.put('/api/v2/item', itemData)
      return responseApi.data
    } catch (error) {
      throw error
    }
  }

  /** Loads one item by product code. */
  async getItemByCode(code: string): Promise<Item> {
    try {
      const responseApi = await apiClient.get(`/api/v2/item/${code}`)
      const concept = itemMapper(responseApi.data)
      return concept
    } catch (error) {
      throw error
    }
  }

  /** Lists items with optional pagination cursor. */
  async getItems(params?: { limit: number, lastEvaluatedKey?: string }): Promise<{ lastEvaluatedKey: string, items: Item[] }> {
    try {
      let url = params !== undefined ? `/api/v2/item?limit=${params.limit}` : '/api/v2/item'
      if (params !== undefined && params.lastEvaluatedKey !== undefined) {
        url = `${url}&lastEvaluatedKey=${params.lastEvaluatedKey}`
      }

      const responseApi = await apiClient.get(url)

      const items = responseApi.data.items.map((item: any) => {
        return itemMapper(item)
      })

      return {
        lastEvaluatedKey: JSON.stringify(responseApi.data.lastEvaluatedKey),
        items: items
      }

    } catch (error) {
      throw error
    }
  }
}

export default ItemService
